import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../Context/GlobalContext";

const TermsAndConditions = () => {
  const { documentContent, getTermsConditions } = useContext(GlobalContext);

  useEffect(() => {
    getTermsConditions();
  }, [getTermsConditions]);

  return (
    <div className="content-part text-break" id="terms-condition">
      <div dangerouslySetInnerHTML={{ __html: documentContent?.terms }}></div>
    </div>
  );
};

export default TermsAndConditions;
